var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 19,
  viewBox: "0 0 19 19"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#528AEA",
  fillRule: "nonzero",
  d: "M2.794 12.128H.223v6.428H6.65v-2.571H2.794v-3.857zM.223 6.986h2.57V3.129H6.65V.56H.223v6.427zm15.426 8.999h-3.857v2.57h6.428v-6.427H15.65v3.857zM11.792.558V3.13h3.857v3.857h2.571V.558h-6.428z"
})));
export default __webpack_public_path__ + "teg/media/open.d13ed30a.svg";
export { SvgComponent as ReactComponent };